var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7732 7.61367L12.6932 2.53369H5.91989C4.98856 2.53369 4.23503 3.29569 4.23503 4.22702L4.22656 17.7736C4.22656 18.705 4.98009 19.467 5.91142 19.467H16.0799C17.0112 19.467 17.7732 18.705 17.7732 17.7736V7.61367ZM16.0799 17.7736H5.91989V4.22702H11.8465V8.46034H16.0799V17.7736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlank);
export default __webpack_public_path__ + "static/media/icon-blank.8e81d04890faefc0cd01e456b19a3a47.svg";
export { ForwardRef as ReactComponent };